export default __webpack_public_path__ + "static/media/capucino-espresso.b77192aa.jpg";